import info_box from '../icons/info_box';
import { font_family_detailed, all_font_families } from '../gb-helper/font_family_detailed';
import color_palette_list from '../gb-helper/color_palette';
import dashicon_list from '../gb-helper/dashicon_list';

const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
const { RichText } = wp.editor;
const { InspectorControls, MediaUpload, MediaUploadCheck, InnerBlocks } = wp.editor;
const { Flex, FlexItem, FlexBlock, Icon, Panel, ToggleControl, TabPanel, PanelBody,
    PanelRow, SelectControl, Dashicon, Card, CardBody, Button, RangeControl,
    ColorIndicator, ColorPalette, TextControl} = wp.components;
// const ALLOWED_BLOCKS = ['core/button'];

registerBlockType('blocksbakery/info-box', {
    title: __('Info Box', 'blocks-bakery'),
    description: __(
        'This box will contain a description along with image or icon with heading in a single block. The block can be customized as per requirements.',
        'blocks-bakery'
    ),

    // common, formatting, layout, widgets, embed
    category: 'blocks-bakery',
    icon: info_box.infobox,
    keywords: [
        __('Info Box', 'blocks-bakery'),
        __('Info', 'blocks-bakery'),
        __('box', 'blocks-bakery')
    ],

    supports: {
        html: false
    },
    attributes: {
        // content
        prefix_heading: {
            type: "string",
            default: "Prefix"
        },
        title_heading: {
            type: "string",
            default: "Info Box"
        },
        description_heading: {
            type: "string",
            default: "Click here to change this text. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo."
        },
        seperator_content: {
            type: "html"
        },
        icon: {
            type: 'string',
            default: 'block'
        },

        image: {
            type: 'string',
            default: 'none'
        },


        // image and icon styling
        img_ID: {
            type: 'number'
        },
        img_URL: {
            type: 'string',
            source: 'attribute',
            attribute: 'src',
            selector: 'img'
        },
        img_alt: {
            type: 'string',
            source: 'attribute',
            attribute: 'alt',
            selector: 'img'
        },
        img_width: {
            type: 'number',
            default: 120
        },
        img_corners: {
            type: 'number',
            default: 0
        },
        color_img: {
            type: 'string',
            default: 'black'
        },
        hover_img: {
            type: 'string',
            default: 'black'
        },
        icon_selector: {
            type: 'string',
            default: 'star-filled'
        },
        select_source: {
            type: 'string',
            default: 'icon'
        },
        icon_size: {
            type: 'number',
            default: 50
        },
        link: {
            type: 'string',
            default: '#'
        },

        // content styling
        prefix_size: {
            type: 'number',
            default: 20
        },
        windowOpen: {
            type: 'string',
        },
        font_family_prefix: {
            type: 'string',
            default: 'ABeeZee'
        },
        prefix_weight: {
            type: 'number',
            default: 400
        },
        themeInherit: {
            type: 'boolean',
            default: false
        },
        line_height_prefix: {
            type: 'number',
            default:30
        },
        color_prefix: {
            type: 'string',
            default: 'black'
        },
        toggle_prefix: {
            type: 'boolean',
            default: true,
        },

        title_size: {
            type: 'number',
        },
        font_family_title: {
            type: 'string',
            default: 'ABeeZee'
        },
        title_weight: {
            type: 'number',
        },
        line_height_title: {
            type: 'number',
            default:30
        },
        color_title: {
            type: 'string',
            default: 'black'
        },
        heading_title: {
            type: 'html',
            default: 'h3'
        },
        toggle_title: {
            type: 'boolean',
            default: true,
        },

        description_size: {
            type: 'number',
            default:20
        },
        font_family_description: {
            type: 'string',
            default: 'ABeeZee'
        },
        description_weight: {
            type: 'number',
        },
        line_height_description: {
            type: 'number',
            default:30
        },
        color_description: {
            type: 'string',
            default: 'black'
        },
        toggle_description: {
            type: 'boolean',
            default: true,
        },

        // seperator styling
        seperator_style: {
            type: "html",
            default: 'solid'
        },
        url_icon1: {
            type: 'string',
            default: 'Read Me'
        },
        seperator_thickness: {
            type: "number",
            default: 1
        },
        seperator_width: {
            type: "number",
            default: 140
        },
        seperator_color: {
            type: 'string',
            default: 'black'
        },
        // spacing icon
        margin_left: {
            type: 'number',
        },
        margin_right: {
            type: 'number',
        },
        margin_top: {
            type: 'number',
        },
        margin_bottom: {
            type: 'number',
            default: '30'
        },
        margin_bt_prefix: {
            type: 'number'
        },
        margin_bt_title: {
            type: 'number'
        },
        margin_bt_seperator: {
            type: 'number'
        },
        margin_bt_description: {
            type: 'number'
        },
        callaction: {
            type: 'string',
            default: 'none'
        },
        readmorebtn: {
            type: "string",
            default: "none"
        },
        readmoretxt: {
            type: "string",
            default: "none"
        },
        bgcolorbtn: {
            type: "string",
            default: ''
        },
        colorbtn: {
            type: "string",
            default: 'black'
        },
        radiusbtn: {
            type: "string",
            default: '1px'
        },

        // postion setting
        seperator_position: {
            type: 'string',
            default: 'aftertitle'
        },
        afterImgIcon: {
            type: "String",
            default: "none"
        },
        afterPrefix: {
            type: "String",
            default: "none"
        },
        afterTitle: {
            type: "String",
            default: "block"
        },
        afterDesc: {
            type: "String",
            default: "none"
        },
        custom_width: {
            type: 'boolean',
            default: true
        },
        positionImgIcon: {
            type: "string",
            default: "abovetitle"
        },
        prefix_px_em: {
            type: "string",
            default: "px"
        },
        title_px_em: {
            type: "string",
            default: "px"
        },
        desc_px_em: {
            type: "string",
            default: "px"
        },
        prefix_lh_px_em: {
            type: "string",
            default: "px"
        },
        title_lh_px_em: {
            type: "string",
            default: "px"
        },
        desc_lh_px_em: {
            type: "string",
            default: "px"
        },
    },
    edit: (props) => {
        var index_prefix = font_family_detailed.findIndex(x => x.family === props.attributes.font_family_prefix);
        var font_weight_prefix = font_family_detailed[index_prefix].variants
        var font_weight_prefix_list = []
        for (var i = 0; i < font_weight_prefix.length; i++) {
            font_weight_prefix_list.push({ label: font_weight_prefix[i], value: font_weight_prefix[i] })
        }
        var index_title = font_family_detailed.findIndex(y => y.family === props.attributes.font_family_title);
        var font_weight_title = font_family_detailed[index_title].variants
        var font_weight_title_list = []
        for (var i = 0; i < font_weight_title.length; i++) {
            font_weight_title_list.push({ label: font_weight_title[i], value: font_weight_title[i] })
        }
        var index_desc = font_family_detailed.findIndex(z => z.family === props.attributes.font_family_description);
        var font_weight_desc = font_family_detailed[index_desc].variants
        var font_weight_desc_list = []
        for (var i = 0; i < font_weight_desc.length; i++) {
            font_weight_desc_list.push({ label: font_weight_desc[i], value: font_weight_desc[i] })
        }
        const select_img = (img) => {
            props.setAttributes({
                img_ID: img.id,
                img_URL: img.url,
                img_alt: img.alt
            })
        };
        const remove_img = () => {
            props.setAttributes({
                img_ID: null,
                img_URL: null,
                img_alt: null
            })
        };
        const prefix_typography = () => {
            var x = document.getElementById("myDIV");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        };
        const themseIherit = (val) => {
            var btn = document.getElementById('button')
            if (val === true) {
                props.setAttributes({ bgcolorbtn: '#1d2327' })
                props.setAttributes({ colorbtn: 'white' })
                props.setAttributes({ radiusbtn: '30px' })
                // btn.style.backgroundColor = '#1d2327'
                // btn.style.color = 'white',
                // btn.style.borderRadius = '30px'
            } else if (val === false) {
                props.setAttributes({ bgcolorbtn: '' })
                props.setAttributes({ colorbtn: 'black' })
                props.setAttributes({ radiusbtn: '1px' })
                // btn.style.borderRadius = '1px'
                // btn.style.backgroundColor = ""
                // btn.style.color = 'black'
            }
        }
        const title_typography = () => {
            var x = document.getElementById("myDIV1");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        };
        const description_typography = () => {
            var x = document.getElementById("myDIV2");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        }
        const sel_src = (val) => {
            var x = document.getElementById("icon_show");
            var y = document.getElementById("img_show");
            var a = document.getElementsByClassName("gb-info-box-ishow")[0];
            var b = document.getElementsByClassName("gb-info-box-imgshow")[0];
            if (val === "icon") {
                x.style.display = "block";
                y.style.display = "none";
                a.style.display = "block";
                b.style.display = "none";
                props.setAttributes({ icon: 'flex' })
                props.setAttributes({ image: 'none' })
            }
            if (val === "image") {
                y.style.display = "block";
                x.style.display = "none";
                b.style.display = "flex";
                a.style.display = "none";
                props.setAttributes({ image: 'flex' })
                props.setAttributes({ icon: 'none' })
            }
        };
        const callaction = (val) => {
            var z = document.getElementById('btn_val')
            var a = document.getElementById('link_val')
            if (val === 'none') {
                z.style.display = "none";
                a.style.display = "none";
            }
            else if (val === "text") {
                z.style.display = "none";
                a.style.display = "block";
            } else if (val === 'button') {
                z.style.display = "block";
                a.style.display = "none";
            }
        };
        const changeBackground = (e) => {
            e.target.style.color = props.attributes.hover_img
        }
        const sameColor = (e) => {
            e.target.style.color = props.attributes.color_img
        };
        const enbl_title = (val) => {
            if (val === true) {
                props.setAttributes({ title_display: 'block' })
            } else if (val === false) {
                props.setAttributes({ title_display: 'none' })
            }
        }
        const enbl_prefix = (val) => {
            if (val === true) {
                props.setAttributes({ prefix_display: 'block' })
            } else if (val === false) {
                props.setAttributes({ prefix_display: 'none' })
            }
        }
        const enbl_descri = (val) => {
            if (val === true) {
                props.setAttributes({ desc_display: 'block' })
            } else if (val === false) {
                props.setAttributes({ desc_display: 'none' })
            }
        }
        const prefixFontPx = () => {
            var prefix_px = document.getElementById('prefix-px')
            var prefix_em = document.getElementById('prefix-em')
            prefix_px.style.textDecoration = "underline"
            prefix_em.style.textDecoration = "none"
            props.setAttributes({ prefix_px_em: 'px' })
        }
        const prefixFontEm = () => {
            var prefix_px = document.getElementById('prefix-px')
            var prefix_em = document.getElementById('prefix-em')
            prefix_em.style.textDecoration = "underline"
            prefix_px.style.textDecoration = "none"
            props.setAttributes({ prefix_px_em: 'em' })
        }
        const prefixLineheightPx = () => {
            var prefix_px_lh = document.getElementById('prefix-px-lh')
            var prefix_em_lh = document.getElementById('prefix-em-lh')
            prefix_px_lh.style.textDecoration = "underline"
            prefix_em_lh.style.textDecoration = "none"
            props.setAttributes({ prefix_lh_px_em: 'px' })
        }
        const prefixLineheightEx = () => {
            var prefix_px_lh = document.getElementById('prefix-px-lh')
            var prefix_em_lh = document.getElementById('prefix-em-lh')
            prefix_em_lh.style.textDecoration = "underline"
            prefix_px_lh.style.textDecoration = "none"
            props.setAttributes({ prefix_lh_px_em: 'em' })
        }
        const titleFontPx = () => {
            var title_px = document.getElementById('title-px')
            var title_em = document.getElementById('title-em')
            title_px.style.textDecoration = "underline"
            title_em.style.textDecoration = "none"
            props.setAttributes({ title_px_em: 'px' })
        }
        const titleFontEm = () => {
            var title_px = document.getElementById('title-px')
            var title_em = document.getElementById('title-em')
            title_em.style.textDecoration = "underline"
            title_px.style.textDecoration = "none"
            props.setAttributes({ title_px_em: 'em' })
        
        }
        const titleLineheihgtPx = () => {
            var title_px_lh = document.getElementById('title-px-lh')
            var title_em_lh = document.getElementById('title-em-lh')
            title_px_lh.style.textDecoration = "underline"
            title_em_lh.style.textDecoration = "none"
            props.setAttributes({ title_lh_px_em: 'px' })
        }
        const titleLineheihgtEm = () => {
            var title_px_lh = document.getElementById('title-px-lh')
            var title_em_lh = document.getElementById('title-em-lh')
            title_em_lh.style.textDecoration = "underline"
            title_px_lh.style.textDecoration = "none"
            props.setAttributes({ title_lh_px_em: 'em' })
        }
        const descriptionFontPx = () => {
            var desc_px = document.getElementById('desc-px')
            var desc_em = document.getElementById('desc-em')
            desc_px.style.textDecoration = "underline"
            desc_em.style.textDecoration = "none"
            props.setAttributes({ desc_px_em: 'px' })
        }
        const descriptionFontEm = () => {
            var desc_px = document.getElementById('desc-px')
            var desc_em = document.getElementById('desc-em')
            desc_px.style.textDecoration = "none"
            desc_em.style.textDecoration = "underline"
            props.setAttributes({ desc_px_em: 'em' })
        }
        const descriptionLineheightPx = () => {
            var desc_px_lh = document.getElementById('desc-px-lh')
            var desc_em_lh = document.getElementById('desc-em-lh')
            desc_px_lh.style.textDecoration = "underline"
            desc_em_lh.style.textDecoration = "none"
            props.setAttributes({ desc_lh_px_em: 'px' })
        }
        const descriptionLineheightEm = () => {
            var desc_px_lh = document.getElementById('desc-px-lh')
            var desc_em_lh = document.getElementById('desc-em-lh')
            desc_em_lh.style.textDecoration = "underline"
            desc_px_lh.style.textDecoration = "none"
            props.setAttributes({ desc_lh_px_em: 'em' })
        }
        const prefixReset = () => {
            props.setAttributes({font_family_prefix:"ABeeZee"});
            props.setAttributes({prefix_size:"20"});
            props.setAttributes({prefix_weight:""});
            props.setAttributes({line_height_prefix:"30"});
        }
        const titleReset = () => {
            props.setAttributes({font_family_title:"ABeeZee"});
            props.setAttributes({title_size:""});
            props.setAttributes({title_weight:""});
            props.setAttributes({line_height_title:"30"});
        }
        const descriptionReset = () => {
            props.setAttributes({font_family_description:"ABeeZee"});
            props.setAttributes({description_size:"20"});
            props.setAttributes({description_weight:""});
            props.setAttributes({line_height_description:"30"});
        }
        const custom_width = (val) => {
            var x = document.getElementById('custom_width')
            if (val === true) {
                props.setAttributes({ img_width: 120 })
                x.style.display = 'block'
            }
            else if (val === false) {
                props.setAttributes({ img_width: '' })
                x.style.display = 'none'
            }
        }
        return [
            <InspectorControls>
                <PanelBody title={__('Image/Icon', 'blocks-bakery')} initialOpen={false} >
                    {/* <SelectControl
                        label="Select Position"
                        options={[
                            { label: 'Above Title', value: 'abovetitle' },
                            { label: 'Below Title', value: 'belowtitle' },
                            { label: 'Left Of Title', value: 'lefttitle' },
                            { label: 'Right Of Title', value: 'righttitle' },
                            { label: 'Left Of Text And Title', value: 'lefttitletxt' },
                            { label: 'Right Of Text And Title', value: 'righttitletxt' },
                        ]}
                        value={props.attributes.positionImgIcon}
                        onChange={(new_val)=>{
                            props.setAttributes({positionImgIcon:new_val})
                            if(new_val==='lefttitletxt'){

                            }
                        }}
                />
                <hr/> */}
                    <SelectControl
                        label="Select Source"
                        options={[
                            { label: 'Icon', value: 'icon' },
                            { label: 'Image', value: 'image' },
                        ]}
                        value={props.attributes.select_source}
                        onChange={(new_val) => {
                            props.setAttributes({ select_source: new_val })
                            sel_src(new_val)
                        }}
                    />
                    <div id='icon_show' style={{ display: 'block' }}>
                        <Card>
                            <CardBody>
                                <SelectControl
                                    label='Select-dash'
                                    value={props.attributes.icon_selector}
                                    options={dashicon_list}
                                    onChange={(new_val) => {
                                        props.setAttributes({ icon_selector: new_val })
                                    }} />
                                <Dashicon icon={props.attributes.icon_selector}
                                />
                            </CardBody>
                        </Card>
                        <br></br>
                        <RangeControl
                            label="Icon Size"
                            allowReset={true}
                            initialPosition={30}
                            min={0}
                            max={300}
                            value={props.attributes.icon_size}
                            onChange={(new_val) => {
                                props.setAttributes({ icon_size: new_val })
                            }}
                        />
                        <TabPanel className="my-tab-panel"
                            activeClass="active-tab"
                            tabs={[
                                {
                                    name: 'Normal',
                                    title: 'Normal',
                                    className: <ColorPalette
                                        colors={color_palette_list}
                                        value={props.attributes.color_img}
                                        onChange={(new_val) => {
                                            props.setAttributes({ color_img: new_val })
                                        }}
                                    />
                                },
                                {
                                    name: 'Hover',
                                    title: 'Hover',
                                    className: <ColorPalette
                                        colors={color_palette_list}
                                        value={props.attributes.hover_img}
                                        onChange={(new_val) => {
                                            props.setAttributes({ hover_img: new_val })
                                        }}
                                    />
                                },
                            ]}>
                            {
                                (tab) => <p>{tab.className}</p>
                            }
                        </TabPanel>
                    </div>
                    <div id='img_show' style={{ display: 'none', }}>
                        {props.attributes.img_ID ? (
                            <div className="image-ctr">
                                <img src={props.attributes.img_URL}
                                    alt={props.attributes.img_alt} />
                                {props.isSelected ? (
                                    <Button className="btn-remove" onClick={remove_img}>
                                        <Dashicon icon='no' size='20' />
                                    </Button>
                                ) : null}
                            </div>
                        ) : (
                            <MediaUploadCheck>
                                <MediaUpload
                                    allowedType={['image']}
                                    value={props.attributes.img_ID}
                                    onSelect={select_img}
                                    render={({ open }) => (
                                        <Button className={"button button-large"} onClick={open}>
                                            {__('Upload Image', 'recipe')}
                                        </Button>
                                    )}></MediaUpload>
                            </MediaUploadCheck>
                        )}
                        <br></br><br></br>
                        <ToggleControl
                            label="Custom Width"
                            checked={props.attributes.custom_width}
                            help={"Turn this off to inherit the natural width of Image."}
                            onChange={(new_val) => {
                                props.setAttributes({ custom_width: new_val })
                                custom_width(new_val)
                            }}
                        />
                        <div id="custom_width">
                            <RangeControl
                                label="Width (px)"
                                allowReset={true}
                                initialPosition={120}
                                min={0}
                                max={500}
                                value={props.attributes.img_width}
                                onChange={(new_val) => {
                                    props.setAttributes({ img_width: new_val })
                                }}
                            />
                        </div>
                        <RangeControl
                            label="Rounded Corners (px)"
                            allowReset={true}
                            initialPosition={0}
                            min={0}
                            max={500}
                            value={props.attributes.img_corners}
                            onChange={(new_val) => {
                                props.setAttributes({ img_corners: new_val })
                            }}
                        />
                    </div>
                </PanelBody>
                <PanelBody title={__('Content', 'blocks-bakery')} initialOpen={false}>
                    <ToggleControl
                        label="Enable Prefix"
                        checked={props.attributes.toggle_prefix}
                        onChange={(new_val) => {
                            props.setAttributes({ toggle_prefix: new_val })
                            enbl_prefix(new_val)
                        }}
                    />
                    <div id="toggle_pre" style={{ display: props.attributes.prefix_display }}>
                        <PanelRow>
                            <p>Typography</p>
                            <div>
                                <Button onClick={prefixReset} style={{ padding: 0 }}><span><Dashicon icon="image-rotate" style={{ fontSize: 15 }} /></span></Button>
                                <Button><span><Dashicon icon="admin-tools" style={{ fontSize: 15 }} onClick={prefix_typography} /></span></Button>
                            </div>
                        </PanelRow>
                        <Card id="myDIV" style={{ display: "none" }}>
                            <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <p style={{ marginRight: 46 }}>Font Size</p>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                    <Button id="prefix-px" onClick={prefixFontPx} primaray style={{ fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                    <Button id="prefix-em" onClick={prefixFontEm} primaray style={{ fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                </div>
                                <div className="range-controller-main">
                                    <div className="textcoloring">
                                    </div>
                                    <div className="range-controler" style={{display:'flex'}}>
                                    <div style={{marginRight:"10px",width:"100%"}}>
                                        <RangeControl
                                            beforeIcon="editor-textcolor"
                                            min={0}
                                            max={100}
                                            initialPosition={20}
                                            step={0.1}
                                            value={props.attributes.prefix_size}
                                            onChange={(new_val) => {
                                                props.setAttributes({ prefix_size: new_val })
                                            }}
                                        />
                                        </div>
                                            <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                            props.setAttributes({prefix_size:"20"})
                                            }}> Reset 
                                        </Button>
                                    </div>
                                    <SelectControl
                                        label="Font Family"
                                        options={all_font_families}
                                        onChange={(new_val) => {
                                            props.setAttributes({ font_family_prefix: new_val })
                                        }}
                                        value={props.attributes.font_family_prefix}
                                    />
                                    <SelectControl
                                        label="Font Weight"
                                        options={font_weight_prefix_list}
                                        onChange={(new_val) => {
                                            props.setAttributes({ prefix_weight: new_val })
                                        }}
                                        value={props.attributes.prefix_weight}
                                    />
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <p style={{ marginRight: 30 }}>Line Height</p>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                        <Button id="prefix-px-lh" onClick={prefixLineheightPx} primaray style={{ textDecoration: "underline", fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                        <Button id="prefix-em-lh" onClick={prefixLineheightEx} primaray style={{ fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                    </div>
                                    <div className="range-controler" style={{display:'flex'}}>
                                    <div style={{marginRight:"10px",width:"100%"}}>
                                    <RangeControl
                                        beforeIcon="editor-textcolor"
                                        initialPosition={20}
                                        step={0.1}
                                        min={0}
                                        max={100}
                                        onChange={(new_val) => {
                                            props.setAttributes({ line_height_prefix: new_val })
                                        }}
                                        value={props.attributes.line_height_prefix}
                                    />
                                    </div>
                                    <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                            props.setAttributes({line_height_prefix:"30"})
                                            }}> Reset 
                                        </Button>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <p>Prefix Color<span>
                            <ColorIndicator
                                style={{ backgroundColor: props.attributes.color_prefix }} /></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            value={props.attributes.color_prefix}
                            onChange={(new_val) => {
                                props.setAttributes({ color_prefix: new_val })
                            }}
                        />
                        <hr />
                    </div>
                    <ToggleControl
                        label="Enable Title"
                        checked={props.attributes.toggle_title}
                        onChange={(new_val) => {
                            props.setAttributes({ toggle_title: new_val })
                            enbl_title(new_val)
                        }}
                    />
                    <div id='enbl_title' style={{ display: props.attributes.title_display }}>
                        <SelectControl
                            label="Title Tag"
                            value={props.attributes.heading_title}
                            options={[
                                { label: 'h1', value: 'h1' },
                                { label: 'h2', value: 'h2' },
                                { label: 'h3', value: 'h3' },
                                { label: 'h4', value: 'h4' },
                                { label: 'h5', value: 'h5' },
                                { label: 'h6', value: 'h6' },
                            ]}
                            onChange={(new_val) => {
                                props.setAttributes({ heading_title: new_val })
                            }}
                        />
                        <PanelRow>
                            <p>Typography</p>
                            <div>
                                <Button onClick={titleReset} style={{ padding: 0 }}><span><Dashicon icon="image-rotate" style={{ fontSize: 15 }} /></span></Button>
                                <Button><span><Dashicon icon="admin-tools" style={{ fontSize: 15 }} onClick={title_typography} /></span></Button>
                            </div>
                        </PanelRow>
                        <Card id="myDIV1" style={{ display: "none" }}>
                            <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <p style={{ marginRight: 46 }}>Font Size</p>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                    <Button id="title-px" onClick={titleFontPx} primaray style={{ fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                    <Button id="title-em" onClick={titleFontEm} primaray style={{ fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                </div>
                                <div className="range-controller-main">
                                    <div className="textcoloring">
                                    </div>
                                    <div className="range-controler" style={{display:"flex"}}>
                                    <div style={{marginRight:"10px",width:"100%"}}>
                                        <RangeControl
                                            beforeIcon="editor-textcolor"
                                            min={0}
                                            max={100}
                                            initialPosition={20}
                                            step={0.1}
                                            value={props.attributes.title_size}
                                            onChange={(new_val) => {
                                                props.setAttributes({ title_size: new_val })
                                            }}
                                        />
                                        </div>
                                         <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                            props.setAttributes({title_size:""})
                                            }}> Reset 
                                        </Button>
                                    </div>
                                    <SelectControl
                                        label="Font Family"
                                        options={all_font_families}
                                        onChange={(new_val) => {
                                            props.setAttributes({ font_family_title: new_val })
                                        }}
                                        value={props.attributes.font_family_title}
                                    />
                                    <SelectControl
                                        label="Font Weight"
                                        options={font_weight_title_list}
                                        onChange={(new_val) => {
                                            props.setAttributes({ title_weight: new_val })
                                        }}
                                        value={props.attributes.title_weight}
                                    />
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <p style={{ marginRight: 30 }}>Line Height</p>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                        <Button id="title-px-lh" onClick={titleLineheihgtPx} primaray style={{ textDecoration: "underline", fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                        <Button id="title-em-lh" onClick={titleLineheihgtEm} primaray style={{ fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                    </div>
                                    <div className="range-controler" style={{display:"flex"}}>
                                    <div style={{marginRight:"10px",width:"100%"}}>
                                    <RangeControl
                                        beforeIcon="editor-textcolor"
                                        initialPosition={1.5}
                                        step={0.1}
                                        min={0}
                                        max={100}
                                        onChange={(new_val) => {
                                            props.setAttributes({ line_height_title: new_val })
                                        }}
                                        value={props.attributes.line_height_title}
                                    />
                                    </div>
                                    <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                            props.setAttributes({line_height_title:"30"})
                                             }}> Reset 
                                  </Button>
                                  </div>
                                </div>
                            </CardBody>
                        </Card>
                        <p>Title Color<span>
                            <ColorIndicator
                                style={{ backgroundColor: props.attributes.color_title }} /></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            onChange={(new_val) => {
                                props.setAttributes({ color_title: new_val })
                            }}
                            value={props.attributes.color_title}
                        />
                        <hr />
                    </div>
                    <ToggleControl
                        label="Enable Description"
                        checked={props.attributes.toggle_description}
                        onChange={(new_val) => {
                            props.setAttributes({ toggle_description: new_val })
                            enbl_descri(new_val)
                        }}
                    />
                    <div id='enbl_descri' style={{ display: props.attributes.desc_display }}>
                        <PanelRow>
                            <p>Typography</p>
                            <div>
                                <Button onClick={descriptionReset}><span><Dashicon icon="image-rotate" style={{ fontSize: 15 }} /></span></Button>
                                <Button><span><Dashicon icon="admin-tools" style={{ fontSize: 15 }} onClick={description_typography} /></span></Button>
                            </div>
                        </PanelRow>
                        <Card id="myDIV2" style={{ display: "none" }}>
                            <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <p style={{ marginRight: 46 }}>Font Size</p>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                    <Button id="desc-px" onClick={descriptionFontPx} primaray style={{ fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                    <Button id="desc-em" onClick={descriptionFontEm} primaray style={{ fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                </div>
                                <div className="range-controller-main">
                                    <div className="textcoloring">
                                    </div>
                                    <div className="range-controler" style={{display:"flex"}}>
                                    <div style={{marginRight:"10px",width:"100%"}}>
                                        <RangeControl
                                            beforeIcon="editor-textcolor"
                                            min={0}
                                            max={100}
                                            initialPosition={20}
                                            step={0.1}
                                            value={props.attributes.description_size}
                                            onChange={(new_val) => {
                                                props.setAttributes({ description_size: new_val })
                                            }}
                                        />
                                        </div>
                                        <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                            props.setAttributes({description_size:"20"})
                                            }}> Reset 
                                        </Button>
                                    </div>
                                    <SelectControl
                                        label="Font Family"
                                        options={all_font_families}
                                        onChange={(new_val) => {
                                            props.setAttributes({ font_family_description: new_val })
                                        }}
                                        value={props.attributes.font_family_description}
                                    />
                                    <SelectControl
                                        label="Font Weight"
                                        options={font_weight_desc_list}
                                        onChange={(new_val) => {
                                            props.setAttributes({ description_weight: new_val })
                                        }}
                                        value={props.attributes.description_weight}
                                    />
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <p style={{ marginRight: 30 }}>Line Height</p>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                        <Button id="desc-px-lh" onClick={descriptionLineheightPx} primaray style={{ textDecoration: "underline", fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                        <Button id="desc-em-lh" onClick={descriptionLineheightEm} primaray style={{ fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                    </div>
                                    <div className="range-controler" style={{display:"flex"}}>
                                    <div style={{marginRight:"10px",width:"100%"}}>
                                    <RangeControl
                                        beforeIcon="editor-textcolor"
                                        initialPosition={1.5}
                                        step={0.1}
                                        min={0}
                                        max={100}
                                        onChange={(new_val) => {
                                            props.setAttributes({ line_height_description: new_val })
                                        }}
                                        value={props.attributes.line_height_description}
                                    />
                                    </div>
                                    <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                            props.setAttributes({line_height_description:"30"})
                                            }}> Reset 
                                        </Button>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <p>Description Color <span>
                            <ColorIndicator
                                style={{ backgroundColor: props.attributes.color_description }} /></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            onChange={(new_val) => {
                                props.setAttributes({ color_description: new_val })
                            }}
                            value={props.attributes.color_description}
                        />
                    </div>
                </PanelBody>
                <PanelBody title={__("Seprator")} initialOpen={false}>
                    <SelectControl
                        label="Position"
                        options={[
                            { label: 'After Icon/Image', value: 'afterimgicon' },
                            { label: 'After Prefix', value: 'afterprefix' },
                            { label: 'After Title', value: 'aftertitle' },
                            { label: 'After Description', value: 'afterdesc' },
                        ]}
                        value={props.attributes.seperator_position}
                        onChange={(new_val) => {
                            props.setAttributes({ seperator_position: new_val })
                            if (new_val === 'afterimgicon') {
                                props.setAttributes({ afterImgIcon: "block" })
                                props.setAttributes({ afterPrefix: "none" })
                                props.setAttributes({ afterTitle: "none" })
                                props.setAttributes({ afterDesc: "none" })
                            }
                            if (new_val === 'afterprefix') {
                                props.setAttributes({ afterImgIcon: "none" })
                                props.setAttributes({ afterPrefix: "block" })
                                props.setAttributes({ afterTitle: "none" })
                                props.setAttributes({ afterDesc: "none" })
                            }
                            if (new_val === 'aftertitle') {
                                props.setAttributes({ afterImgIcon: "none" })
                                props.setAttributes({ afterPrefix: "none" })
                                props.setAttributes({ afterTitle: "block" })
                                props.setAttributes({ afterDesc: "none" })
                            }
                            if (new_val === 'afterdesc') {
                                props.setAttributes({ afterImgIcon: "none" })
                                props.setAttributes({ afterPrefix: "none" })
                                props.setAttributes({ afterTitle: "none" })
                                props.setAttributes({ afterDesc: "block" })
                            }
                        }}
                    />
                    <SelectControl
                        label="Style"
                        options={[
                            { label: 'None', value: 'None' },
                            { label: 'Solid', value: 'solid' },
                            { label: 'Double ', value: 'double' },
                            { label: 'Dashed', value: 'dashed' },
                            { label: 'Dotted', value: 'dotted' }
                        ]}
                        onChange={(new_val) => {
                            props.setAttributes({ seperator_style: new_val })
                        }}
                        value={props.attributes.seperator_style}
                    />
                    <div id='seperator'>
                        <RangeControl
                            allowReset={true}
                            label="Thickness (px)"
                            min={0}
                            max={10}
                            onChange={(new_val) => {
                                props.setAttributes({ seperator_thickness: new_val })
                            }}
                            value={props.attributes.seperator_thickness}
                        />
                        <RangeControl
                            allowReset={true}
                            label="Width"
                            initialPosition={140}
                            min={0}
                            max={500}
                            onChange={(new_val) => {
                                props.setAttributes({ seperator_width: new_val })
                            }}
                            value={props.attributes.seperator_width}
                        />
                        <p>Separator Color<span>
                            <ColorIndicator
                                style={{ backgroundColor: props.attributes.seperator_color }} /></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            value={props.attributes.seperator_color}
                            onChange={(new_val) => {
                                props.setAttributes({ seperator_color: new_val })
                            }}
                        />
                    </div>
                </PanelBody>
                <PanelBody title={__('Call To Action', 'blocks-bakery')} initialOpen={false}>
                    <SelectControl
                        label="Type"
                        options={[
                            { label: 'None', value: 'none' },
                            { label: 'Text', value: 'text' },
                            { label: 'Button', value: 'button' },
                        ]}
                        value={props.attributes.callaction}
                        onChange={(new_val) => {
                            props.setAttributes({ callaction: new_val })
                            if (new_val === 'none') {
                                props.setAttributes({ readmoretxt: 'none' })
                                props.setAttributes({ readmorebtn: 'none' })
                            }
                            if (new_val === 'text') {
                                props.setAttributes({ readmoretxt: 'block' })
                                props.setAttributes({ readmorebtn: 'none' })
                            }
                            if (new_val === 'button') {
                                props.setAttributes({ readmoretxt: 'none' })
                                props.setAttributes({ readmorebtn: 'block' })
                            }
                            callaction(new_val)
                        }}
                    />
                    <div id='btn_val' style={{ display: 'none' }}>
                        <p>Text </p>
                        <TextControl
                            value={props.attributes.url_icon1}
                            onChange={(new_val) => {
                                props.setAttributes({ url_icon1: new_val })
                            }} />
                        <ToggleControl
                            label="Inherit from Theme"
                            checked={props.attributes.themeInherit}
                            onChange={(new_val) => {
                                props.setAttributes({ themeInherit: new_val })
                                themseIherit(new_val)
                            }} />
                        <p>Link</p>
                        <TextControl
                            value={props.attributes.link}
                            onChange={(new_val) => {
                                props.setAttributes({ link: new_val })
                            }} />
                        <SelectControl
                            label="Open in Current/New Window"
                            options={[
                                { label: 'New Window', value: '_blank' },
                                { label: 'Same Window', value: '_self' },
                            ]}
                            value={props.attributes.windowOpen}
                            onChange={(new_val) => {
                                props.setAttributes({ windowOpen: new_val })
                            }}
                        />
                    </div>
                    <div id='link_val' style={{ display: 'none' }}>
                        <p>Text </p>
                        <TextControl
                            value={props.attributes.url_icon1}
                            onChange={(new_val) => {
                                props.setAttributes({ url_icon1: new_val })
                            }} />
                        <p>Link</p>
                        <TextControl
                            value={props.attributes.link}
                            onChange={(new_val) => {
                                props.setAttributes({ link: new_val })
                            }} />
                        <SelectControl
                            label="Open in Current/New Window"
                            options={[
                                { label: 'New Window', value: '_blank' },
                                { label: 'Same Window', value: '_self' },
                            ]}
                            value={props.attributes.windowOpen}
                            onChange={(new_val) => {
                                props.setAttributes({ windowOpen: new_val })
                            }}
                        />
                    </div>
                </PanelBody>
                <PanelBody title={__("Spacing")} initialOpen={false}>
                    <RangeControl
                        label="Prefix Bottom Margin"
                        allowReset={true}
                        min={0}
                        max={500}
                        initialPosition={5}
                        value={props.attributes.margin_bt_prefix}
                        onChange={(new_val) => {
                            props.setAttributes({ margin_bt_prefix: new_val })
                        }}
                    />
                    <RangeControl
                        label="Title Bottom Margin"
                        allowReset={true}
                        min={0}
                        max={500}
                        initialPosition={10}
                        value={props.attributes.margin_bt_title}
                        onChange={(new_val) => {
                            props.setAttributes({ margin_bt_title: new_val })
                        }}
                    />
                    <RangeControl
                        label="Seprator Bottom Margin"
                        allowReset={true}
                        min={0}
                        max={500}
                        initialPosition={10}
                        value={props.attributes.margin_bt_seperator}
                        onChange={(new_val) => {
                            props.setAttributes({ margin_bt_seperator: new_val })
                        }}
                    />
                    <RangeControl
                        label="Description Bottom Margin"
                        allowReset={true}
                        min={0}
                        max={500}
                        initialPosition={10}
                        value={props.attributes.margin_bt_description}
                        onChange={(new_val) => {
                            props.setAttributes({ margin_bt_description: new_val })
                        }}
                    />
                    <hr />
                    <h2>Image/Icon Margin (px)</h2>
                    {<svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.656 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M0.984 2.999v14c0 1.103 0.896 2 2 2h0.797v-18h-0.797c-1.104 0-2 0.897-2 2z"></path></svg>}
                    <RangeControl
                        allowReset={true}
                        min={0}
                        max={500}
                        initialPosition={310}
                        value={props.attributes.margin_left}
                        onChange={(new_val) => {
                            props.setAttributes({ margin_left: new_val })
                        }}
                    />
                    {<svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.656 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M19.015 16.999v-14c0-1.103-0.896-2-2-2h-0.797v18h0.797c1.104 0 2-0.896 2-2z"></path></svg>}
                    <RangeControl
                        allowReset={true}
                        min={0}
                        max={500}
                        initialPosition={310}
                        value={props.attributes.margin_right}
                        onChange={(new_val) => {
                            props.setAttributes({ margin_right: new_val })
                        }}
                    />
                    {<svg width="20" height="20"><path fill="#999" d="M17 1c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17 0h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M17 0.984h-14c-1.103 0-2 0.897-2 2v0.797h18v-0.797c0-1.103-0.897-2-2-2z"></path></svg>}
                    <RangeControl
                        allowReset={true}
                        min={0}
                        max={500}
                        initialPosition={5}
                        value={props.attributes.margin_top}
                        onChange={(new_val) => {
                            props.setAttributes({ margin_top: new_val })
                        }}
                    />
                    {<svg width="20" height="20"><path fill="#999" d="M17 1c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17 0h-14c-1.657 0-3 1.343-3 3v14c0 1.656 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M3 19.016h14c1.103 0 2-0.896 2-2v-0.797h-18v0.797c0 1.103 0.897 2 2 2z"></path></svg>}
                    <RangeControl
                        allowReset={true}
                        min={0}
                        max={500}
                        initialPosition={20}
                        value={props.attributes.margin_bottom}
                        onChange={(new_val) => {
                            props.setAttributes({ margin_bottom: new_val })
                        }}
                    />
                </PanelBody>
            </InspectorControls>,
            <div className="gb-info-box">
                <div className="gb-info-box-ishow" style={{
                    textAlign: "center", width: props.attributes.img_width, margin: 'auto'
                    , display: "block"
                }}>
                    <Dashicon className='gb-info-box-icon-styling' onMouseOver={changeBackground} onMouseLeave={sameColor} icon={props.attributes.icon_selector} style={{
                        marginLeft: props.attributes.margin_left, marginRight: props.attributes.margin_right, marginTop: props.attributes.margin_top,
                        marginBottom: props.attributes.margin_bottom, color: props.attributes.color_img, fontSize: props.attributes.icon_size, width: props.attributes.icon_size, height: props.attributes.icon_size
                    }} />
                </div>
                <div className="gb-info-box-imgshow for me" style={{
                    width: "100%",
                    display: "none", justifyContent: 'center',
                }}>
                    {props.attributes.img_ID ? (
                        <div className="image-ctr" style={{ marginBottom: '30px', }}>
                            <img style={{
                                borderRadius: props.attributes.img_corners, width: props.attributes.img_width,
                                marginLeft: props.attributes.margin_left,
                                marginRight: props.attributes.margin_right,
                                marginTop: props.attributes.margin_top,
                                marginBottom: props.attributes.margin_bottom,
                            }}
                                src={props.attributes.img_URL}
                                alt={props.attributes.img_alt} />
                        </div>
                    ) : (
                        <MediaUploadCheck>
                            <MediaUpload

                                allowedType={['image']}
                                value={props.attributes.img_ID}
                                onSelect={select_img}
                                render={({ open }) => (
                                    <Button className={"button button-large"} onClick={open}>
                                        {__('Upload Image', 'blocks-bakery')}
                                    </Button>
                                )}></MediaUpload>
                        </MediaUploadCheck>
                    )}
                </div>
                <hr className='bg-info-box-seperator'
                    value={props.attributes.seperator_content}
                    onChange={(new_val) => {
                        props.setAttributes({ seperator_content: new_val })
                    }}
                    style={{
                        margin: 'auto', display: props.attributes.afterImgIcon,
                        marginTop: '10px', marginBottom: props.attributes.margin_bt_seperator, border: props.attributes.seperator_style, borderWidth: props.attributes.seperator_thickness,
                        width: props.attributes.seperator_width, color: props.attributes.seperator_color, height: "0"
                    }} />
                <RichText
                    className="gb-info-box-prefix"
                    tagName="p"
                    value={props.attributes.prefix_heading}
                    onChange={(new_val) => {
                        props.setAttributes({ prefix_heading: new_val })
                    }}
                    style={{
                        display: props.attributes.prefix_display,
                        textAlign: "center", padding: 0, marginBottom: props.attributes.margin_bt_prefix, fontSize: props.attributes.prefix_size+props.attributes.prefix_px_em,
                        fontWeight: props.attributes.prefix_weight, lineHeight: props.attributes.line_height_prefix+props.attributes.prefix_lh_px_em, fontFamily: props.attributes.font_family_prefix, color: props.attributes.color_prefix
                    }}
                />
                <hr className='bg-info-box-seperator'
                    value={props.attributes.seperator_content}
                    onChange={(new_val) => {
                        props.setAttributes({ seperator_content: new_val })
                    }}
                    style={{
                        margin: 'auto', display: props.attributes.afterPrefix,
                        marginTop: '10px', marginBottom: props.attributes.margin_bt_seperator, border: props.attributes.seperator_style, borderWidth: props.attributes.seperator_thickness,
                        width: props.attributes.seperator_width, color: props.attributes.seperator_color, height: "0"
                    }} />
                <RichText
                    className='gb-info-box-title-heading'
                    tagName={props.attributes.heading_title}
                    value={props.attributes.title_heading}
                    onChange={(new_val) => {
                        props.setAttributes({ title_heading: new_val })
                    }}
                    style={{
                        display: props.attributes.title_display,
                        textAlign: "center", padding: 0, marginBottom: props.attributes.margin_bt_title, fontSize: props.attributes.title_size+props.attributes.title_px_em,
                        fontWeight: props.attributes.title_weight, lineHeight: props.attributes.line_height_title+props.attributes.title_lh_px_em, fontFamily: props.attributes.font_family_title, color: props.attributes.color_title
                    }}
                />
                <hr className='bg-info-box-seperator'
                    value={props.attributes.seperator_content}
                    onChange={(new_val) => {
                        props.setAttributes({ seperator_content: new_val })
                    }}
                    style={{
                        margin: 'auto', display: props.attributes.afterTitle,
                        marginTop: '10px', marginBottom: props.attributes.margin_bt_seperator, border: props.attributes.seperator_style, borderWidth: props.attributes.seperator_thickness,
                        width: props.attributes.seperator_width, color: props.attributes.seperator_color, height: "0"
                    }} />
                <RichText
                    className='gb-info-box-description'
                    tagName="p"
                    value={props.attributes.description_heading}
                    onChange={(new_val) => {
                        props.setAttributes({ description_heading: new_val })
                    }}
                    style={{
                        display: props.attributes.desc_display,
                        textAlign: "center", padding: 0, marginBottom: props.attributes.margin_bt_description, fontSize: props.attributes.description_size+props.attributes.desc_px_em,
                        fontWeight: props.attributes.description_weight, lineHeight: props.attributes.line_height_description+props.attributes.desc_lh_px_em, fontFamily: props.attributes.font_family_description, color: props.attributes.color_description
                    }}
                />
                <hr className='bg-info-box-seperator'
                    value={props.attributes.seperator_content}
                    onChange={(new_val) => {
                        props.setAttributes({ seperator_content: new_val })
                    }}
                    style={{
                        margin: 'auto', display: props.attributes.afterDesc,
                        marginTop: '10px', marginBottom: props.attributes.margin_bt_seperator, border: props.attributes.seperator_style, borderWidth: props.attributes.seperator_thickness,
                        width: props.attributes.seperator_width, color: props.attributes.seperator_color, height: "0"
                    }} />
                <br></br>
                <div className='gb-info-box-link-first' style={{ display: props.attributes.readmoretxt, textAlign: 'center' }}>
                    <a href={props.attributes.link} target={props.attributes.windowOpen} style={{ fontWeight: 'bolder' }}>{props.attributes.url_icon1}</a>
                </div>
                <div className='gb-info-box-link-second' style={{ display: props.attributes.readmorebtn, textAlign: 'center' }}>
                    <a id="button" href={props.attributes.link} target={props.attributes.windowOpen} style={{ textDecoration: 'none', border: "solid", borderRadius: props.attributes.radiusbtn, color: props.attributes.colorbtn, padding: '10px', backgroundColor: props.attributes.bgcolorbtn }}>{props.attributes.url_icon1}</a>
                </div>
            </div>
        ]
    },
    save: (props) => {

        const changeBackground = (e) => {
            e.target.style.color = props.attributes.hover_img
        }
        const sameColor = (e) => {
            e.target.style.color = props.attributes.color_img
        };
        return (
            <div className={props.className}>
                <div className="gb-info-box-ishow" style={{
                    textAlign: "center", width: props.attributes.img_width, margin: 'auto',
                    display: "flex", justifyContent: 'center'
                }}>
                    <Dashicon className='gb-info-box-icon-styling' onMouseOver={() => {
                        this.style.color = 'red'
                    }} onMouseLeave={() => {
                        this.style.color = 'green'
                    }} icon={props.attributes.icon_selector} style={{
                        display: props.attributes.icon,
                        marginLeft: props.attributes.margin_left, marginRight: props.attributes.margin_right, marginTop: props.attributes.margin_top,
                        marginBottom: props.attributes.margin_bottom, color: props.attributes.color_img, fontSize: props.attributes.icon_size, width: props.attributes.icon_size, height: props.attributes.icon_size
                    }} />
                </div>
                <div class="for me" style={{
                    display: props.attributes.image,
                    justifyContent: 'center',
                }}>
                    <div className="image-ctr" style={{ marginBottom: '30px', }}>
                        <img style={{
                            borderRadius: props.attributes.img_corners, width: props.attributes.img_width,
                            marginRight: props.attributes.margin_right,
                            marginTop: props.attributes.margin_top,
                            marginBottom: props.attributes.margin_bottom,
                            marginLeft: props.attributes.margin_left,
                        }}
                            src={props.attributes.img_URL}
                            alt={props.attributes.img_alt} />
                    </div>
                </div>
                <hr className='bg-info-box-seperator'
                    value={props.attributes.seperator_content}
                    onChange={(new_val) => {
                        props.setAttributes({ seperator_content: new_val })
                    }}
                    style={{
                        margin: 'auto', display: props.attributes.afterImgIcon,
                        marginTop: '10px', marginBottom: props.attributes.margin_bt_seperator, border: props.attributes.seperator_style, borderWidth: props.attributes.seperator_thickness,
                        width: props.attributes.seperator_width, color: props.attributes.seperator_color, height: "0"
                    }} />
                <RichText.Content
                    className="gb-info-box-prefix"
                    tagName="p"
                    value={props.attributes.prefix_heading}
                    style={{
                        display: props.attributes.prefix_display,
                        textAlign: "center", padding: 0, marginBottom: props.attributes.margin_bt_prefix, fontSize: props.attributes.prefix_size+props.attributes.prefix_px_em,
                        fontWeight: props.attributes.prefix_weight, lineHeight: props.attributes.line_height_prefix+props.attributes.prefix_lh_px_em, fontFamily: props.attributes.font_family_prefix, color: props.attributes.color_prefix
                    }}
                />
                <hr className='bg-info-box-seperator'
                    value={props.attributes.seperator_content}
                    onChange={(new_val) => {
                        props.setAttributes({ seperator_content: new_val })
                    }}
                    style={{
                        margin: 'auto', display: props.attributes.afterPrefix,
                        marginTop: '10px', marginBottom: props.attributes.margin_bt_seperator, border: props.attributes.seperator_style, borderWidth: props.attributes.seperator_thickness,
                        width: props.attributes.seperator_width, color: props.attributes.seperator_color, height: "0"
                    }} />
                <RichText.Content
                    className='gb-info-box-title-heading'
                    tagName={props.attributes.heading_title}
                    value={props.attributes.title_heading}
                    style={{
                        display: props.attributes.title_display,
                        textAlign: "center", padding: 0, marginBottom: props.attributes.margin_bt_title, fontSize: props.attributes.title_size+props.attributes.title_px_em,
                        fontWeight: props.attributes.title_weight, lineHeight: props.attributes.line_height_title+props.attributes.title_lh_px_em, fontFamily: props.attributes.font_family_title, color: props.attributes.color_title
                    }}
                />
                <hr className='bg-info-box-seperator'
                    value={props.attributes.seperator_content}
                    onChange={(new_val) => {
                        props.setAttributes({ seperator_content: new_val })
                    }}
                    style={{
                        margin: 'auto', display: props.attributes.afterTitle,
                        marginTop: '10px', marginBottom: props.attributes.margin_bt_seperator, border: props.attributes.seperator_style, borderWidth: props.attributes.seperator_thickness,
                        width: props.attributes.seperator_width, color: props.attributes.seperator_color, height: "0"
                    }} />
                <RichText.Content
                    className='gb-info-box-description'
                    tagName="p"
                    value={props.attributes.description_heading}
                    style={{
                        display: props.attributes.desc_display,
                        textAlign: "center", padding: 0, marginBottom: props.attributes.margin_bt_description, fontSize: props.attributes.description_size+props.attributes.desc_px_em,
                        fontWeight: props.attributes.description_weight, lineHeight: props.attributes.line_height_description+props.attributes.desc_lh_px_em, fontFamily: props.attributes.font_family_description, color: props.attributes.color_description
                    }}
                />
                <hr className='bg-info-box-seperator'
                    value={props.attributes.seperator_content}
                    onChange={(new_val) => {
                        props.setAttributes({ seperator_content: new_val })
                    }}
                    style={{
                        margin: 'auto', display: props.attributes.afterDesc,
                        marginTop: '10px', marginBottom: props.attributes.margin_bt_seperator, border: props.attributes.seperator_style, borderWidth: props.attributes.seperator_thickness,
                        width: props.attributes.seperator_width, color: props.attributes.seperator_color, height: "0"
                    }} />
                <br></br>
                <div className='gb-info-box-link-first' style={{ display: props.attributes.readmoretxt, textAlign: 'center' }}>
                    <a href={props.attributes.link} target={props.attributes.windowOpen} style={{ fontWeight: 'bolder' }}>{props.attributes.url_icon1}</a>
                </div>
                <div className='gb-info-box-link-second' style={{ display: props.attributes.readmorebtn, textAlign: 'center' }}>
                    <a id="button" href={props.attributes.link} target={props.attributes.windowOpen} style={{ textDecoration: 'none', border: "solid", borderRadius: props.attributes.radiusbtn, color: props.attributes.colorbtn, padding: '10px', backgroundColor: props.attributes.bgcolorbtn }}>{props.attributes.url_icon1}</a>
                </div>
            </div>
        )
    }
});